import { Chip } from '@mui/material'
import { Model } from 'metalworks-domain'
import { match } from 'ts-pattern'

const getColor = (status: Model.BulkPlateFinalizationStatus) => {
  return match(status)
    .with(Model.BulkPlateFinalizationStatus.New, () => 'info')
    .with(Model.BulkPlateFinalizationStatus.Generated, () => 'info')
    .with(Model.BulkPlateFinalizationStatus.Submitting, () => 'warning')
    .with(Model.BulkPlateFinalizationStatus.Submitted, () => 'success')
    .with(Model.BulkPlateFinalizationStatus.Failed, () => 'error')
    .exhaustive()
}

interface BulkFinalizationStatusProps {
  status: Model.BulkPlateFinalizationStatus
}

export const BulkFinalizationStatus = (props: BulkFinalizationStatusProps) => {
  const { status } = props

  return (
    <>
      <Chip color={getColor(status)} label={status} />
    </>
  )
}
